import React from 'react';
import { Tooltip } from 'antd';
import type { ShipmentProjection } from '../api/kcc';
import CarrierLogo from './CarrierLogo';

type Props = {
  shipment: Pick<
    ShipmentProjection,
    | 'channelShipmentId'
    | 'carrierCode'
    | 'carrierName'
    | 'carrierTrackingUrl'
    | 'vesselName'
    | 'vesselVoyage'
  >;
  logoHeight?: number;
};

function vesselLabel(shipment: Props['shipment']): string | null {
  const name = shipment.vesselName?.trim();
  if (!name) return null;
  const voyage = shipment.vesselVoyage?.trim();
  return voyage ? `${name} ${voyage}` : name;
}

/** 转单号 / 船次 + 承运商 logo + 查询链接（列表与详情共用） */
const CarrierTrackingNo: React.FC<Props> = ({ shipment, logoHeight = 16 }) => {
  const no = shipment.channelShipmentId?.trim() || null;
  const vessel = vesselLabel(shipment);
  if (!no && !vessel) return <>—</>;

  const url = shipment.carrierTrackingUrl;
  const carrier = shipment.carrierName || shipment.carrierCode || 'carrier';
  const trackTitle = vessel && !no ? `Track vessel on ${carrier} website` : `Track on ${carrier} website`;
  const trackText = vessel && !no ? `Track vessel on ${carrier}` : `Track on ${carrier}`;

  return (
    <div style={{ minWidth: 0, wordBreak: 'break-word' }}>
      {no && <div>{no}</div>}
      {vessel && <div>{vessel}</div>}
      {url && (
        <Tooltip title={trackTitle}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, marginTop: 2, flexWrap: 'wrap' }}
          >
            <CarrierLogo code={shipment.carrierCode} name={shipment.carrierName} height={logoHeight} />
            <span>{trackText}</span>
          </a>
        </Tooltip>
      )}
    </div>
  );
};

export default CarrierTrackingNo;
